import { useMemo } from 'react'
import { BookPage } from './pages/BookPage'
import { ManagePage } from './pages/ManagePage'
import { CenteredState } from './components/BookingShell'
import { readRoute } from './lib/route'

export default function App() {
  const route = useMemo(
    () => readRoute(window.location.pathname, window.location.search),
    [],
  )

  if (route.name === 'book') {
    return <BookPage slug={route.slug} />
  }

  if (route.name === 'manage') {
    return <ManagePage token={route.token} />
  }

  return (
    <CenteredState
      title="Nothing to book here"
      description="Open the booking link your practice gave you, or the link in your confirmation email."
    />
  )
}
